/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Marketing_ContextInputs */

const en_wb_marketing_context = /** @type {(inputs: Wb_Marketing_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly review`)
};

const lv_wb_marketing_context = /** @type {(inputs: Wb_Marketing_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mēneša pārskats`)
};

/**
* | output |
* | --- |
* | "Monthly review" |
*
* @param {Wb_Marketing_ContextInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_marketing_context = /** @type {((inputs?: Wb_Marketing_ContextInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Marketing_ContextInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_marketing_context(inputs)
	return en_wb_marketing_context(inputs)
});